import React, { useState } from 'react'

import ModalBase from 'components/Luxkit/Modal/ModalBase'

import EnterCode from './EnterCode'
import Success from './Success'
import { RedeemedCard } from './common'

function RedeemGiftCard() {
  const [currentStep, setCurrentStep] = useState<'enterCode' | 'success'>('enterCode')
  const [redeemedCards, setRedeemedCards] = useState<Array<RedeemedCard>>([])

  const moveToSuccess = (redeemedCard: RedeemedCard) => {
    setRedeemedCards((prevRedeemedCards) => [...prevRedeemedCards, redeemedCard])
    setCurrentStep('success')
  }

  const moveToSummary = () => {
    setCurrentStep('success')
  }

  return (
    <ModalBase height="full" tabletHeight="auto">
      {currentStep === 'enterCode' && (
        <EnterCode moveToSuccess={moveToSuccess} moveToSummary={redeemedCards.length ? moveToSummary : undefined}/>
      )}
      {currentStep === 'success' && (
        <Success redeemedCards={redeemedCards} onRedeemAnother={() => setCurrentStep('enterCode')} />
      )}
    </ModalBase>
  )
}

export default RedeemGiftCard
